export var contactContainer = {
    marginRight: '1.5px',
    lineHeight: '25px',
    display: 'inline-block',
    overflow: 'hidden',
    verticalAlign: 'middle',
};
export var contactContainerNew = {
    marginRight: '1.5px',
    display: 'inline-block',
    overflow: 'hidden',
    verticalAlign: 'middle',
};
export var websiteContainer = {
    display: 'inline-block',
    verticalAlign: 'middle',
};
//# sourceMappingURL=styles.js.map